<template>
  <div id="m-home">
    <div id="loadingWrap">
      <div class="load-box">
        <img class="m-vertical" src="@/assets/images/mobile/vertical.png" alt="">
        <p class="m-loading-text">より良いゲーム体験のため、端末を縦向きにしてください。</p>
      </div>
    </div>
    <div id="m-content">
      <MHead ref="mhead" @slideto="slideChangeFn" @changeindex="changeindexFn"></MHead>

      <div class="mhead-box" @click="closeList">
        <!-- 1 -->
        <section class="msection" id="msection1">
          <img class="videobtn" v-if="_myData.yt" @click="videoFn" v-lazy="require(`@/assets/images/mobile/1/video.png`)" alt="">
          <div class="down-btns-wrap topgradient">
            <div v-if="isDmg" class="start-btn" @click="showStart"></div>
            <div v-if="!isDmg" class="ios-wrap">
              <img class="icon-items" @click="jumpFn('ios')" :src="require(`@/assets/images/mobile/1/${_myData.yuyue ? 'rs' : ''}ios.png`)" alt="">
              <img class="icon-items" @click="jumpFn('google')" :src="require(`@/assets/images/mobile/1/${_myData.yuyue ? 'rs' : ''}google.png`)" alt="">
            </div>
            <img class="icon-register" v-if="_myData.yuyue" @click="goRegister" :src="require(`@/assets/images/mobile/1/register.png`)" alt="">
          </div>
        </section>
        <!-- 2 -->
        <section class="msection" id="msection2">
          <div class="news-wrap backimgstyle">
              <div class="news-tab">
                <p class="news-tab-item" :class="{'active-item': currentTab == 0}" @click="changeTab(0)">公式Twitter</p>
                <p class="news-tab-item" :class="{'active-item': currentTab == 1}" @click="changeTab(1)">NEWS</p>
              </div>
              <div class="news-tab-content">
                <!-- twitter -->
                <div class="tab-content-tw" :style="{opacity: currentTab == 0 ? 1 : 0}">
                  <div class="twBox">
                    <a
                      class="twitter-timeline"
                      data-theme="light"
                      data-link-color="#FAB81E"
                      :href="twitter"
                      >Tweets by AkakuroJP</a
                    >
                  </div>
                  <div
                    @click="twFn"
                    class="tw-btn backimgstyle"
                  ></div>
                </div>

                <!-- news -->
                <div class="tab-news">
                  <div class="tab-content-head"  v-if="currentTab == 1">
                    <div class="tab-head-title">
                      <div class="tab-title-box">
                        <span class="title-item" :class="{ybline: newsTabIndex == index}" @click="changeChannel(index)"  v-for="(item, index) in _myData.news" :key="index">{{item.name}}</span>
                      </div>
                    </div>
                    <i class="tab-more" @click="jumpNews"></i>
                  </div>
                  <div class="tab-content-list" v-if="_myData.news && currentTab == 1">
                    <div class="list-item" @click="jumpDetail(item)"  v-for="(item, index) in _myData.news[newsTabIndex].list" :key="index">
                      <span class="title">{{item.title}}</span>
                      <span class="publish_time">{{item.publish_time}}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
        </section>
        <!-- 3 -->
        <section class="msection" id="msection3" v-lazy:background-image="{ src: require('@/assets/images/mobile/3/back.jpg') }"></section>
        <!-- 4 -->
        <section class="msection" id="msection4" v-lazy:background-image="{ src: require('@/assets/images/mobile/4/back.jpg') }">
          <!-- 英雄轮播 -->
            <div class="hero-wrap">
              <div class="hero-swiper-button-prev backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/4/prev.png') }"></div>
              <div class="hero-swiper-button-next backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/4/next.png') }"></div>
              <div class="hero-swiper-container">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in heronum"
                    :key="index"
                  >
                    <img class="hero-slide-item" :src="require(`@/assets/images/mobile/4/hero/${item}.png`)" alt="" />
                    <img class="hero-slide-name" :src="require(`@/assets/images/mobile/4/name/${item}.png`)" alt="" />
                    <span class="hero-voice-icon" @click="openAudio(item)">
                      <i class="hevoice backimgstyle" :style="{backgroundImage: 'url(' + require('@/assets/images/mobile/horn_mb'+hersicon+'.png') + ')'}"></i>
                    </span>
                    <audio id="heroaudio1" class="voice-audio1" controls >
                      <source :src="require(`@/assets/audio/hero/${vnamearr[item]}.mp3`)" type="audio/mp3">
                    </audio>
                  </div>
                </div>
              </div>
            </div>

            <!-- 底部小图轮播 -->
            <div class="role-wrap">
              <div class="role-swiper-button-prev backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/4/r_prev.png') }"></div>
              <div class="role-swiper-button-next backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/4/r_next.png') }"></div>
              <div class="role-swiper-container backimgstyle">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in heronum"
                    :key="index"
                  >
                    <!-- <img class="role-slide-item" :src="require(`@/assets/images/mobile/4/role/${item}.png`)" alt="" />
                    <img class="role-slide-text" :src="require(`@/assets/images/mobile/4/text/${item}.png`)" alt="" /> -->
                    <!-- <span class="role-beauty-box backimgstyle" >
                      <img class="role-img" :src="require(`@/assets/images/mobile/4/avatar/${item}.png`)" alt="">
                    </span>
                    <span class="role-gray-box backimgstyle">
                      <img class="role-img" :src="require(`@/assets/images/mobile/4/avatar/${index > (heronum-2) ? 1 : (item+1)}.png`)" alt="">
                    </span> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="role-box">
              <img class="role_current" :src="require(`@/assets/images/mobile/4/role/${roleIndex+1}.png`)" alt="">
              <img class="role_next" :src="require(`@/assets/images/mobile/4/text/${roleIndex+1}.png`)" alt="">
              <span class="role-beauty-box backimgstyle" >
                <img class="role_image" :src="require(`@/assets/images/mobile/4/avatar/${roleIndex+1}.png`)" alt="">
              </span>
              <span class="role-gray-box backimgstyle">
                <img class="role_image" :src="require(`@/assets/images/mobile/4/avatar/${roleIndex > (heronum-2) ? 1 : (roleIndex+2)}.png`)" alt="">
              </span>
            </div>
        </section>
        <!-- 5 -->
        <section class="msection" id="msection5" v-lazy:background-image="{ src: require('@/assets/images/mobile/5/back.jpg') }">
          <div class="chact-wrap">
            <div class="chact-swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in _myData.bannerList"
                  :key="index"
                >
                  <img class="chact-slide-item" :src="item" alt="" />
                </div>
              </div>
            </div>
            <div class="chact-swiper-pagination"></div>
            <div class="chact-swiper-button-prev backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/5/prev.png') }"></div>
            <div class="chact-swiper-button-next backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/5/next.png') }"></div>
          </div>
        </section>
        <!-- 6 -->
        <section v-if="_myData.showFaq" class="msection" id="msection6" v-lazy:background-image="{ src: require('@/assets/images/mobile/6/back.jpg') }">
            <div class="faq-box backimgstyle" v-lazy:background-image="{ src: require('@/assets/images/mobile/6/text_back.png') }">
              <div class="faq-list" v-for="(item, index) in _myData.faq" :key="index">
                <div class="text-title">
                  <div class="q">Q{{ index + 1 }}</div>
                  <div class="question"><span class="multiEsisClass">{{ item.title }}</span></div>
                </div>
                <div class="answer">{{ item.content }}</div>
              </div>
              <div
                @click="jumpFaq"
                class="faq-btn backimgstyle"
                v-lazy:background-image="{
                  src: require('@/assets/images/mobile/6/btn.png'),
                }"
              ></div>
            </div>
        </section>

            <MBottom v-if="!isDmg" class="pg-bottom"></MBottom>
            <BottomCom v-if="isDmg"></BottomCom>
      </div>


    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { TweenMax } from "gsap";
import { clearParams } from "@/util/index"
import MHead from "@/components/mobile/m-head";
import MBottom from "@/components/mobile/m-bottom";
import BottomCom from "@/components/BottomCom";
import { isPc } from "@/util/index"

export default {
  components: {
    MHead, MBottom, BottomCom
  },
  computed: {
    ...mapState(["_myData"]),
    isDmg() {
      return this.$route.name === 'dmg'
    },
  },
  watch: {
    heroSwiper: {
      handler (val) {
        if (val && !val.controller.control) {
          setTimeout(()=>{
            this.heroSwiper.controller.control = this.roleSwiper;
          }, 300)
        }
      },
      immediate: true
    },
    activeIndex: {
      handler (val) {

        if(this.$refs.mhead) {
          this.$refs.mhead.setActiveIndex(val);
        }

        // 角色轮播
        if ((val == 3 || val == 4 || val == 5) && !this.chactSwiper) {
          this.$nextTick(()=>{
            this.initChactSwiper();
          })
        }
        // 英雄轮播
        if ((val == 2 || val == 3 || val == 4) && !this.heroSwiper) {
          this.$nextTick(()=>{
            this.initHeroSwiper();
            this.initRoleSwiper();
          })
        }


      },
      immediate: true
    }
  },
  data() {
    return {
      // 主页面参数
      listData: ['home', 'news', 'story', 'chact', 'system', 'faq'],  //列表数据
      activeIndex: 0,   // 当前轮播索引
      showList: false,  // 列表展示显隐
      // 2 news
      currentTab: 0, // 当前tab
      newsTabIndex: 0,   // 当前点击channel索引
      twitter: 'https://twitter.com/AkakuroJP',
      // 4
      heroSwiper: null,    // 英雄轮播
      roleSwiper: null,    // 小英雄轮播
      heronum: 13,  // 英雄的展示数量
      // 5
      chactSwiper: null,   // 角色轮播

      sectionHeight: 0,

      vnamearr: {
        1: 'akx',
        2: 'als',
        3: 'bz',
        4: 'hh',
        5: 'lfe',
        6: 'lsl',
        7: 'll',
        8: 'fes',
        9: 'mets',
        10: 'xm',
        11: 'llt',
        12: 'tgre',
        13: 'ydl'
      },
      hersicon: 2,
      voiceInterval: null,

      roleIndex: 0,


    };
  },
  created () {

    // twitter初始化
    this.initTwitter()

    // 获取进来时的模块索引
    if (this.$route.query.index) {
      this.activeIndex = Number(this.$route.query.index);
      this.$nextTick(()=>{
        this.slideChangeFn(this.activeIndex);
      })
      this.$router.push({ query: {} });
    }
  },
  mounted() {
    // window.scrollTo({top:0});
    const dom1 = document.querySelector('.mhead-box');
      dom1.scrollTo({
        top: 0 // 滚动终点y的位置
      });

    // 获取模块高度
    const msection1 = document.querySelector('#msection1');
    this.sectionHeight = parseInt(this.getDomType(msection1, 'height'));

    // 监听滚动
    const dom = document.querySelector('.mhead-box');
    dom.addEventListener("scroll", this.debounce(this.scrollFn), false);

  },
  methods: {
    showStart() {
			layer.open({
				content: 'このゲームはPC専用です。',
				time: 2,
				skin: 'msg'
			})
    },

    twFn() {
      window.open(this.twitter, "_self");
    },

    debounce(fn) {
      return () => {
        if (this.timeout !== null) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(fn, 10);
      };
    },

    scrollFn() {
      this.activeIndex = parseInt(this.getScrollTop() / this.sectionHeight);
    },

    getScrollTop() {
      const dom = document.querySelector('.mhead-box');
      return dom.scrollTop;
    },

    // 打开列表
    openList() {
      this.showList = !this.showList;
    },

    closeList() {
      this.showList = false;
      if (this.$refs.mhead) {
        this.$refs.mhead.closeListFn();
      }
    },

    // 点击滚动到相应slide
    slideChangeFn(index) {
      // const dom = document.querySelector('.mhead-box');
      // this.activeIndex = index;

      // window.scrollTo({
      //   top: this.sectionHeight * index, // 滚动终点y的位置
      //   behavior: 'smooth', //平滑滚动
      // });
    },

    // 切换tab
    changeTab(num) {
      if (num != this.currentTab) {
        this.currentTab = num;
      }
    },

    // system轮播初始化
    initChactSwiper() {
      const _this = this;
      if (this.chactSwiper) {
        this.chactSwiper.destroy(false);
      }

      this.chactSwiper = new Swiper(".chact-swiper-container", {
        loop: true,
        centeredSlides: true,
        pagination: {
          el: ".chact-swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".chact-swiper-button-next",
          prevEl: ".chact-swiper-button-prev",
        },
      });

    },

    // 切换频道
    changeChannel(index) {
      this.newsTabIndex = index;
    },
    // 查看当前频道的更多列表
    jumpNews () {
      this.$store.dispatch('setChannelId', this._myData.news[0].id)
      this.$router.push({name: 'news'})
    },
    // 查看文章详情
    jumpDetail (item) {
      const id = item.id;
      this.$router.push({name: 'detail', query: {id}})
    },

    // 推特初始化
    initTwitter() {
      let script = document.createElement("script")
      script.type = "text/javascript";
      script.src = "https://platform.twitter.com/widgets.js"
      document.getElementsByTagName("head")[0].appendChild(script);
    },

    // 英雄轮播初始化
    initHeroSwiper() {
      const _this = this;
      if (this.heroSwiper) {
        this.heroSwiper.destroy(false);
      }
      this.heroSwiper = new Swiper(".hero-swiper-container", {
        loop:true,
        // observer:true,
        navigation: {
          nextEl: ".hero-swiper-button-next",
          prevEl: ".hero-swiper-button-prev",
          disabledClass: 'my-button-disabled',
        },
        controller: {
          control: this.roleSwiper,
        },
        on:{
          slideChange: () => {
            this.clearvoice();
          },
        },
      });
    },

    // 小英雄轮播初始化
    initRoleSwiper() {
      const _this = this;
      if (this.roleSwiper) {
        this.roleSwiper.destroy(false);
      }
      this.roleSwiper = new Swiper(".role-swiper-container", {
        loop:true,
        centeredSlides: true,
        allowTouchMove: false,
        navigation: {
          nextEl: ".role-swiper-button-next",
          prevEl: ".role-swiper-button-prev",
          disabledClass: 'my-button-disabled',
        },
        controller: {
          control: this.heroSwiper,
        },
        on:{
          slideChange: () => {
            this.clearvoice();
            if (this.roleSwiper) {
              this.roleIndex = this.roleSwiper.realIndex;
            }
          },
        },
      });
    },

    clearvoice () {
      const audio = document.getElementById("heroaudio1");
      if (audio && !audio.paused) {
        audio.pause();
        this.hersicon = 2;
        window.clearInterval(this.voiceInterval);
      }
    },

    // 查看faq列表
    jumpFaq() {
      this.$router.push({name: 'detail', query: {id: 'faq', origin: this.$route.name}});
    },

    goRegister() {
      const url = window.location.origin + '/register'
      window.open(url, "_self");
    },

    // 下载按钮跳转
    jumpFn(code) {
      if ( code == 'ios' ) {
        const url = this._myData.yuyue ? this._myData.submit_ios : this._myData.ios;
        if (url) {
          window.open(url, "_self");
        } else {
          layer.open({
            content: 'まだ公開されていません。しばらくお待ちください。',
            time: 2,
            skin: 'msg'
          })
        }
      } else {
        const val = this._myData.yuyue ? ('submit_'+code) : code
        window.open(this._myData[val], "_self")
      }
    },

    videoFn() {
      window.open(this._myData.yt, "_self")
    },

    changeindexFn(index) {
      this.activeIndex = index;
    },

    getDomType(dom, style) {
      const styles = this.getStyle(dom, style);
      const height = styles.slice(0, styles.length -2);
      return Number(height);
    },
    // 获取样式
    getStyle(el, attr) {
        if (el && el.currentStyle) {
          // IE,OPER
          return el.currentStyle[attr]
        } else {
          // chrome、safari、FireFox
          return window.getComputedStyle(el)[attr]
        }
    },

    // 打开音频
    openAudio (item) {
      const audio = document.getElementById("heroaudio1");
      if (audio.paused) {
        audio.src = require(`@/assets/audio/hero/${this.vnamearr[item]}.mp3`)
        audio.play();
      }
      audio.addEventListener("playing", ()=>{
        this.hersicon = 2;
        this.intervalFn();
      });
      audio.addEventListener("pause", ()=>{
        this.hersicon = 2;
        window.clearInterval(this.voiceInterval);
      });
    },

    intervalFn() {
      if (this.voiceInterval) {
        window.clearInterval(this.voiceInterval);
      }
      this.voiceInterval = setInterval(()=>{
        this.hersicon = this.hersicon == 1 ? 2 : 1;
      }, 300)
    },


  },
};
</script>

<style lang="scss" scope>
@import "@/assets/scss/views/mobile/m-home.scss";
.douyin-video {
  position: absolute;
  width: 375px;
  height: 600px;
  z-index: 9999999999;
}
</style>
